import React, { type FC, type PropsWithChildren, useState } from 'react';
import { CheckValidationContext } from './CheckValidationContext';

const CheckValidationContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const [checkValidation, setICheckValidation] = useState(false);

  const handleSetValidation = (validate: boolean) => {
    setICheckValidation(validate);
  };
  return (
    <CheckValidationContext.Provider
      value={{ checkValidation, setICheckValidation: handleSetValidation }}
    >
      {children}
    </CheckValidationContext.Provider>
  );
};

export default CheckValidationContextProvider;
